import { Component, OnDestroy, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject, retry } from "rxjs";
import { SubSink } from "subsink";
import * as _ from "lodash";
import moment from "moment";
import { NgForm } from "@angular/forms";
import { OnboardingService } from "../../../../shared/services/onboarding.service";
import { NbcLoggerService } from "../../../../shared/logger/nbc-logger.service";

@Component({
  selector: "editPositionRequest-onb",
  templateUrl: "./editPositionRequest.component.html",
  standalone: false
})
export class EditPositionRequestComponent implements OnInit, OnDestroy {
  hrOnboardingItem: any;
  positionRequestInfo: any;
  isRequiredValidation = true;
  submitted: any;
  date: any;
  positionStartDate: any;
  productionManager: any;
  reportsTo: any;
  contacts: any;
  modelValue: any;
  result: any;
  proxyEmail = "";
  public onSync!: Subject<any>;
  frmEditPositionRequest: any;
  disableSubmitPositionRequestButtonOnClick = false;

  selectedCompanyCode: any;
  selectedProxyName: any;
  companyCodes: any;
  proxyList: any;

  //to hold the values before update

  beforeEditPosStartDate: any;
  beforeEditCompCode: any;
  beforeEditProxy: any;

  isDirtyPositionStartDate = false;
  isDirtyCompanyCode = false;
  isDirtyProxyName = false;

  isFormDirty = true;

  showAlertMessage = false;

  constructor(
    public bsModalRef: BsModalRef,
    private _onboardingService: OnboardingService,
    private log: NbcLoggerService
  ) {
  }

  modalTitle = "";
  isPositionStartDateInvalid = false;
  private subs = new SubSink();

  //Closing Modal
  closeModal() {
    this.bsModalRef.hide();
  }

  proxySelected(selectedProxy) {
    if (selectedProxy)
      this.proxyEmail = selectedProxy?.name;
    else
      this.proxyEmail = "";
  }

  savePositionRequest(frmEditPositionRequest: NgForm) {
    this.submitted = true;
    this.isFormDirty = this.validateCustomControls();

    if (!this.isFormDirty) {
      this.log.trace("No data updated in the modal .");
      this.log.showModalError("There are no changes saved.");
      this.showAlertMessage = true;
    }

    if (frmEditPositionRequest.valid && this.isFormDirty) {
      this.disableSubmitPositionRequestButtonOnClick = true;
      this.save();
    } else {
      this.submitted = false;
      this.isFormDirty = false;
    }
  }

  validateCustomControls() {
    if (this.beforeEditCompCode != this.selectedCompanyCode.description) {
      this.isDirtyCompanyCode = true;
    }

    if (this.beforeEditPosStartDate != this.positionStartDate) {
      this.isDirtyPositionStartDate = true;
    }

    if (this.beforeEditProxy != this.selectedProxyName?.description) {
      this.isDirtyProxyName = true;
    }

    return (
      this.isDirtyCompanyCode ||
      this.isDirtyPositionStartDate ||
      this.isDirtyProxyName
    );
  }

  save() {
    this.log.trace("save updated Position Request");
    this.hrOnboardingItem.companyCode = this.selectedCompanyCode?.description;
    this.hrOnboardingItem.positionStartDate = moment(this.positionStartDate).format("MM/DD/yyyy");
    this.hrOnboardingItem.proxyId = this.selectedProxyName?.id;
    this.hrOnboardingItem.proxyName = this.selectedProxyName?.description;

    this.subs.sink = this._onboardingService.updateOnboardingPositionRequest(this.hrOnboardingItem).subscribe(
      (result) => {
        this.result = result.reference;
        this.log.showSuccess(
          "The Position Request has been successfully updated"
        );
        this.onSync.next(
          "The Position Request has been successfully updated."
        );
        this.isFormDirty = false;
        this.bsModalRef.hide();
      },
      (err) => {
        console.log(err.error);
        this.log.trace(
          "The position request was not updated " + err.error
        );
        this.log.showModalError(
          "The position request was not updated."
        );
        this.showAlertMessage = true;
      }
    );
  }

  cancel() {
    this.log.trace("cancel edit position request modal");
    this.isRequiredValidation = false;
    this.bsModalRef.hide();
    this.submitted = false;
    this.isFormDirty = false;
  }

  ngOnInit(): void {
    this.onSync = new Subject();
    this.hrOnboardingItem = this.hrOnboardingItem;
    this.companyCodes = this.companyCodes;
    this.proxyList = this.proxyList;

    this.selectedCompanyCode = this.companyCodes.find(
      item => (item.description || "") === this.hrOnboardingItem?.companyCode
    ) || null;

    this.selectedProxyName = this.proxyList.find(
      item => (item.id || "") == this.hrOnboardingItem?.proxyId
    ) || null;

    this.positionStartDate = moment(this.hrOnboardingItem?.positionStartDate, "MM/DD/YYYY").toDate();
    this.beforeEditPosStartDate = this.positionStartDate;
    this.beforeEditCompCode = this.hrOnboardingItem?.companyCode;
    this.beforeEditProxy = this.hrOnboardingItem?.proxyName;
    this.proxyEmail = this.selectedProxyName?.name;

    console.log(this.hrOnboardingItem);
    console.log(this.proxyList);
    console.log(this.selectedProxyName);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
